<script setup>
import { onMounted, ref } from 'vue'
import {Icon, Input, ProfilePicture, Textarea} from '@components'

import CenterLayout from './CenterLayout.vue'

const questions = ref('We are almost there! Please login or signup to continue with the booking.')
const loginOptions = ref(['Login into my account', ' Create new account'])

import { useChatCustomizer } from '@store/chatCustomizer';
const $chatCustomizer = useChatCustomizer();

import {useSettings} from '@store/settings';
const $settings = useSettings();

</script>

<template>
  <CenterLayout>
    <div class="h-[66px] w-[297px] rounded-md overflow-hidden m-auto mb-10">
      <img @click="$chatCustomizer.changeSecondaryMenu('time')" :src="Image('chat-customizer-top-banner.png')" class="opacity-30 cursor-pointer" alt="">
    </div>
    
    <div class="mb-10 text-center font-semibold text-lg">...</div>
    <div class="rounded-[14px] p-5 flex flex-col gap-5 bg-white w-[381px] m-auto">
      <div class="flex flex-col gap-3">
        <div class="text-sm font-medium">Questions</div>
        <Textarea v-model="$settings.settings.chat_widget.customer_information.question"></Textarea>
      </div>
     
      <div class="flex gap-2 flex-wrap">
        <div v-for="option in loginOptions" :key="option" @click="selectedSlot = slot" class="flex items-center gap-2 rounded-[58px] p-[10px_24px_10px_15px] cursor-pointer border border-[#D0D5DD]">
            <Icon name="sun" size="20px"/>
            <div class="text-[#101828] text-base font-medium">{{ option }}</div>
        </div>
      </div>
    </div>

    <template #sidebar>
      <div class="mt-[44px]">
        <div class="text-[#101828] text-xs font-semibold">Pro Tips</div>
        <div class="text-[#101828] text-lg font-semibold mt-1">Personal Information</div>
        <ul class="pl-5 mt-1 text-sm text-[#475467] list-disc">
          <li>Set your login options</li>
        </ul>
      </div>
    </template>
  </CenterLayout>
</template>


<style>

</style>